import { createAsyncThunk } from '@reduxjs/toolkit'

import { AccountsApi } from '../api/accountsApi'
import { GetAccountsRequest, SetCfdStatusRequest } from '../api/types'

// ---------------------------------------------------------------------

export const SLICE_NAME = 'accounts'

export const GetAccounts = createAsyncThunk(
  `${SLICE_NAME}/getAll`,
  async (data: GetAccountsRequest, thunkAPI) => {
    const res = await AccountsApi.getAllAccounts(data)

    if (res.success) return res

    return thunkAPI.rejectWithValue(null)
  },
)

export const SetAccountCfdStatus = createAsyncThunk(
  `${SLICE_NAME}/setCfdStatus`,
  async (data: SetCfdStatusRequest, thunkAPI) => {
    const res = await AccountsApi.setCfdStatus(data)

    if (res.success) return res

    return thunkAPI.rejectWithValue(null)
  },
)
